module.exports = __webpack_public_path__ + "static/media/card-mobile-bg-basic.f6a2e7ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Plans/card-mobile-bg-basic.jpg
// module id = 330
// module chunks = 0